import React from "react";

const FreeTrial = () => {
  return <>Free Trial</>;
};

export default FreeTrial;
